import { Button, Stack, Text } from '@lmc/design-system'
import { Modal } from 'antd'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import { useTranslation } from 'react-i18next'
import { StepModalFooter, StepModalTitle } from './StepConfirmDiscard'

type LogUpdateConfirmProps = {
  onCancel: () => void
  onContinue: () => void
  open: boolean
  testId: string
}

/**
 * Warns that saving changes the incident log too, so an exported copy may no
 * longer match. Cancel keeps the edits on the step, unsaved.
 */
const LogUpdateConfirm = ({
  onCancel,
  onContinue,
  open,
  testId
}: LogUpdateConfirmProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  return (
    <Modal
      data-testid={testId}
      footer={
        <StepModalFooter>
          <Button
            data-testid={`${testId}-cancel`}
            onClick={onCancel}
            variant="secondary"
          >
            {t(incidentReportsConstants.CASE_V2_LOG_UPDATE_CANCEL)}
          </Button>
          <Button data-testid={`${testId}-continue`} onClick={onContinue}>
            {t(incidentReportsConstants.CASE_V2_LOG_UPDATE_CONTINUE)}
          </Button>
        </StepModalFooter>
      }
      onCancel={onCancel}
      open={open}
      title={
        <StepModalTitle forwardedAs="span" variant="heading-md" weight="medium">
          {t(incidentReportsConstants.CASE_V2_LOG_UPDATE_TITLE)}
        </StepModalTitle>
      }
    >
      <Stack gap="100">
        <Stack gap="200">
          <Text>{t(incidentReportsConstants.CASE_V2_LOG_UPDATE_BODY)}</Text>
          <Text>{t(incidentReportsConstants.CASE_V2_LOG_UPDATE_EXPORTED)}</Text>
        </Stack>
        <Text weight="medium">
          {t(incidentReportsConstants.CASE_V2_LOG_UPDATE_QUESTION)}
        </Text>
      </Stack>
    </Modal>
  )
}

export default LogUpdateConfirm
